import { useToastContext } from '@payaca/ambrosia';

const useCopyToClipboard = () => {
  const { pushSuccess } = useToastContext();
  const handleCopy = async (text: string) => {
    await navigator.clipboard.writeText(text);
    pushSuccess('Copied to clipboard');
  };

  return { handleCopy };
};

export default useCopyToClipboard;
